<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.title'></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import 'element-ui/lib/theme-chalk/index.css';
@import "./assets/css/flex.css";
@import "./assets/css/iconfont.css";
body {
		width: 100%;
		margin: 0;
		box-sizing: border-box;
}
#app {
  width: 100%;
  /* text-align: center; */
  color: #2c3e50;
  margin-top: 0px;
}

#app * {
	box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/App.vue